__turbopack_context__.v({
  "className": "roboto_db5a2c1d-module__Aj0D3q__className",
  "variable": "roboto_db5a2c1d-module__Aj0D3q__variable",
});
